import { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import EditProject from './EditProject';
import { useDispatch, useSelector } from 'react-redux';
import { getMember, getProjects } from '../../../redux/MainAction';
import PaginationComponent from '../filters/PaginationComponent';
import ProjectDetails from './ProjectDetails';

const ProjectsList = ({ data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const [editID, setEditID] = useState('');
  const dispatch = useDispatch();
  const projList = useSelector((state) => state?.Webtracker?.projects);
  const emp = useSelector((state) => state?.Webtracker?.member);

  // Function to toggle the modal visibility

  const [filter, setFilter] = useState({
    employeeIds: '',
  });

  const [projects, setProjectList] = useState([]);
  const [page, setPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(0); // Total number of pages
  const itemsPerPage = 10;

  const [showReset, setShowReset] = useState(false);

  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilter({ ...filter, [name]: value });
  };

  const toggleModal = (id) => {
    setIsModalOpen(!isModalOpen);
    setEditID(id);
  };

  const toggleDetailsModal = (id) => {
    setEditID(id);
    setIsDetailsModalOpen(!isDetailsModalOpen);
  };

  useEffect(() => {
    getList();
  }, [page]);

  const getList = () => {
    var data2 = {
      offset: (page - 1) * itemsPerPage,
      limit: itemsPerPage,
    };
    dispatch(getProjects(data2));
  };

  useEffect(() => {
    dispatch(getMember());
  }, []);

  useEffect(() => {
    if (projList && projList?.rows && projList?.count) {
      setProjectList(projList?.rows);
      setTotalPages(Math.ceil(projList.count / itemsPerPage));
    }
  }, [projList, page]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleReset = (e) => {
    e.preventDefault();
    const payload = {
      offset: (page - 1) * itemsPerPage,
      limit: itemsPerPage,
    };
    dispatch(getProjects(payload));
    setShowReset(false);
    setFilter({ employeeIds: '' });
  };

  const handleApply = (e) => {
    e.preventDefault();

    let payload = {
      offset: (page - 1) * itemsPerPage,
      limit: itemsPerPage,
    };

    if (filter?.employeeIds !== 'All Members') {
      payload.employeeIds = [filter.employeeIds];
    } else {
      payload = {
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      };
    }

    dispatch(getProjects(payload));
    setShowReset(true);
  };

  return (
    <div className="mt-3">
      <div className="d-flex justify-content-between align-items-center mt-2 mb-2">
        <div
          className="d-flex justify-content-start align-items-center"
          style={{ gap: '10px' }}
        >
          <div className="fillSelect">
            <i className="mdi mdi-briefcase font-20 fillIcon"></i>
            <select
              className="form-control font-14"
              name="employeeIds"
              value={filter?.employeeIds}
              onChange={onChangeFilter}
            >
              <option>All Members</option>
              {emp?.rows?.map((mems, idx) => (
                <option key={idx} value={mems?.id}>
                  {mems?.firstName} {mems?.lastName}
                </option>
              ))}
            </select>
          </div>
          <Button
            className="d-flex align-items-center justify-content-center"
            style={{ padding: '6px 14px' }}
            size="sm"
            color="primary"
            onClick={handleApply}
          >
            <i className="ion-ios7-search font-20"></i>
          </Button>
          {showReset ? (
            <Button
              className="d-flex align-items-center justify-content-center"
              style={{ padding: '6px 13px' }}
              size="sm"
              color="danger"
              onClick={handleReset}
            >
              <i className="mdi mdi-close font-20"></i>
            </Button>
          ) : (
            ''
          )}
        </div>
      </div>
      <div style={{ overflow: 'auto' }}>
        <table
          id="datatable"
          className="table dt-responsive nowrap table-vertical"
          width="100%"
          cellSpacing="0"
        >
          <thead>
            <tr>
              <th>No.</th>
              <th>Project</th>
              <th>Notes</th>
              <th className="text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {projects?.map((prj, idx) => (
              <tr key={idx}>
                <td>{idx + 1 + (page - 1) * itemsPerPage}</td>
                <td>{prj?.name}</td>
                <td>{prj?.projectNotes || 'N/A'}</td>
                <td>
                  <div
                    className="d-flex align-items-center justify-content-end w-100"
                    style={{ gap: '0.5rem' }}
                  >
                    <i
                      className="mdi mdi-lead-pencil font-20 text-primary"
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleModal(prj?.id)}
                      title="Edit Project"
                    ></i>

                    <i
                      className="mdi mdi-eye font-20 text-muted"
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleDetailsModal(prj?.id)}
                      title="Show Project Details"
                    ></i>
                  </div>
                </td>
              </tr>
            ))}
            {/* Add other rows as needed */}
          </tbody>
        </table>
        <PaginationComponent
          count={totalPages}
          page={page}
          onPageChange={handlePageChange}
        />
      </div>

      {/* Pass `isModalOpen` and `toggleModal` to `EditProject` */}
      {isModalOpen && (
        <EditProject open={isModalOpen} onClose={toggleModal} ID={editID} />
      )}

      {isDetailsModalOpen && (
        <ProjectDetails
          open={isDetailsModalOpen}
          onClose={toggleDetailsModal}
          ID={editID}
        />
      )}
    </div>
  );
};

export default ProjectsList;
